<template lang='pug'>
  .product-reviews-sort-and-filters
    template(v-if='!hideFilters')
      template(v-if='!(reviewsCount == 0 && excludeUSReviewsFilter)')
        .filter-container(v-if='isEnhancedMwebReviewPage')
          div
            button.sort-btn.btn.btn-block.btn-white.sort-filter-btn(@click.prevent.stop='toggleSortDropdown')
              span.button-text.capitalize-text(v-text='getSortByText')
              i.dropdown-arrow.dropdown-nav

            transition.row(name='fade' mode='out-in')
              .option-container(v-show='showSort')
                ul.sort-filter-container
                  li.sort-filter-option(v-for='option in sortByOptions' :value='option.value' @click.prevent.stop='setSortBy($event.target.getAttribute("value"))')
                      span(v-if='reviewsSortBy == option.value')
                        .selected
                      span(v-else)
                        .unselected
                      a.option-text {{ option.text }}

          div
            button.filter-btn.btn.btn-block.btn-white.sort-filter-btn(@click='toggleMobileFilter')
              span.badge.applied-filters-count(v-if='appliedFiltersCount > 0' v-text='appliedFiltersCount')
              span.button-text.capitalize-text(v-text='$t("products.reviews.filter")')
              .svg-icon.filter-icon

            ReviewsMobileFilter(:variants='variantsSortedByName'
                                @filterApplied='fetchReviews'
                                @updateAppliedFiltersCount="setAppliedFiltersCount($event)")
        template(v-else)
          .row
            div(:class='variants.length > 1 ? "col-6" : "col-12"')
              button.sort-btn.btn.btn-block.btn-white(@click.prevent.stop='toggleSortDropdown')
                span.button-text(v-text='$t("products.reviews.sort")')
                i.dropdown-arrow.dropdown-nav

              transition.row(name='fade' mode='out-in')
                .reviews-sort(v-show='showSort')
                  ul.sort-filter-container
                    li.sort-filter-option(v-for='option in sortByOptions' :value='option.value' @click.prevent.stop='setSortBy($event.target.getAttribute("value"))')
                      a.option-text {{ option.text }}
                      span.selected(v-if='reviewsSortBy == option.value')

            .col-6
              button.filter-btn.btn.btn-block.btn-white(v-if='variants.length > 1' @click.prevent.stop='toggleFilterDropdown')
                span.button-text(v-text='optionTypeText')
                i.dropdown-arrow.dropdown-nav

              transition.row(name='fade' mode='out-in')
                .reviews-filter(v-show='showFilter')
                  ul.sort-filter-container
                    li.sort-filter-option(value='all' @click='setFilterByVariantIds($event.target.getAttribute("value"))')
                      a.option-text(v-text='$t("common.all")')
                      span.selected(v-if='reviewsFilterByVariantIds.length === 0')
                    li.sort-filter-option(v-for='variant in variantsSortedByName' :value='variant.id' @click.prevent.stop='setFilterByVariantIds($event.target.getAttribute("value"))')
                      a.option-text {{ variant.attributes['name'] }}
                      span.selected(v-if='reviewsFilterByVariantIds[0] === variant.id')

          ProductReviewsHeaderUSFilter(v-if='!isCrossMarketReviewApiFlagOn').col-12.us-filter-container(@fetchReviews='fetchReviews')
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { reviewsMixin } from '@/mixins/reviews-mixin'
import ReviewsMobileFilter from './reviews-mobile-filter.vue'
import { pushDataLayerEvent } from '@/modules/services/gtm'

export default {
  components: {
    ProductReviewsHeaderUSFilter: () => import('../product-reviews-header-us-filter.vue'),
    ReviewsMobileFilter
  },

  mixins: [
    reviewsMixin
  ],

  data () {
    return {
      showSort: false,
      showFilter: false,
      isEnhancedMwebReviewPage: false,
      isCrossMarketReviewApiFlagOn: false,
      appliedFiltersCount: 0
    }
  },

  computed: {
    ...mapState({
      excludeUSReviewsFilter: state => state.review.excludeUSReviewsFilter,
      variants: state => state.product.productVariants,
      reviewsCount: state => state.review.count,
      reviewsSortBy: state => state.review.sortBy,
      reviewsFilterByVariantIds: state => state.review.filterByVariantIds,
      reviewsFilterByRating: state => state.review.filterByRating,
      reviewsFilterByCountry: state => state.review.filterByCountry,
      showMobileFilter: state => state.review.showMobileFilter,
      product: state => state.product.product
    }),
    ...mapGetters([
      'variantsSortedByName',
      'productOptionType'
    ]),
    optionTypeText () {
      return this.$t(`products.reviews.${this.productOptionType}`)
    },
    sortByOptions () {
      return [
        { value: 'recent', text: this.$t('products.reviews.sortMostRecent') },
        { value: '-recent', text: this.$t('products.reviews.sortLeastRecent') }
      ]
    },
    hideFilters () {
      return this.reviewsFilterByVariantIds.length === 0 && this.reviewsCount === 0 && !this.excludeUSReviewsFilter && this.reviewsFilterByRating === null && this.reviewsFilterByCountry === null
    },
    getSortByText () {
      const selectedOption = this.sortByOptions.find(
        option => option.value === this.reviewsSortBy
      )
      return selectedOption ? selectedOption.text : `${this.$t('products.reviews.sortMostRecent')}`
    }
  },

  created () {
    window.addEventListener('click', this.closeFilterSort)
  },

  watch: {
    showSort () {
      if (!this.showSort) {
        const sortByValue = this.reviewsSortBy === 'recent' ? 'newest' : (this.reviewsSortBy === '-recent' ? 'oldest' : '')
        this.recordFilterSelectionGtm('sort', sortByValue)
      }
    }
  },

  mounted () {
    this.isEnhancedMwebReviewPage = this.$kameleoon.isFeatureFlagActive('enable_enhanced_mweb_review_page')
    this.isCrossMarketReviewApiFlagOn = this.$kameleoon.isFeatureFlagActive('enable_cross_market_review_api')
  },

  destroyed () {
    window.removeEventListener('click', this.closeFilterSort)
  },

  methods: {
    toggleSortDropdown () {
      this.showSort = !this.showSort
      this.showFilter = false
    },

    toggleFilterDropdown () {
      this.showFilter = !this.showFilter
      this.showSort = false
    },

    closeFilterSort () {
      this.showFilter = false
      this.showSort = false
    },

    toggleMobileFilter () {
      this.$store.commit('setShowMobileFilter', !this.showMobileFilter)
      this.recordFilterBtnClickGtmEvent()
    },

    setSortBy (sortBy) {
      this.$store.commit('setReviewsSortBy', sortBy)
      this.$store.commit('setReviewsPage', 1)
      this.fetchReviews()
      this.closeFilterSort()
      this.$scrollTo('#product-reviews', 600, {
        offset: -120
      })
    },

    setFilterByVariantIds (variantIds) {
      if (variantIds === 'all') {
        this.$store.commit('setReviewsFilterByVariantIds', [])
      } else {
        this.$store.commit('setReviewsFilterByVariantIds', variantIds)
      }
      this.$store.commit('setReviewsPage', 1)
      this.fetchReviews()
      this.closeFilterSort()
    },

    setAppliedFiltersCount (appliedFiltersCount) {
      this.appliedFiltersCount = appliedFiltersCount
    },

    recordFilterBtnClickGtmEvent () {
      pushDataLayerEvent(
        'click_filter_reviews', {
          params: {
            product_id: this.product.id
          }
        }
      )
    },

    recordFilterSelectionGtm (filterType, selectedValue) {
      pushDataLayerEvent(
        'click_filter_reviews', {
          params: {
            product_id: this.product.id,
            filter_type: filterType,
            filter_value: selectedValue
          }
        }
      )
    }
  }
}
</script>

<style scoped lang='scss'>
  .fade-enter-active, .fade-leave-active {
    transition: max-height .3s;
  }

  .fade-enter-active {
     max-height: 300px;
  }

  .fade-enter,
  .fade-leave-active {
      max-height: 0;
  }

  .fade-leave {
      max-height: 300px;
  }

  .product-reviews-sort-and-filters {
    width: 100%;
    display: block;
  }

  .filter-container {
    display: flex;
    gap: 15px;
  }

  .sort-btn,
  .filter-btn {
    border: 1px solid $grey;

    &:active,
    &:focus,
    &:hover {
      opacity: 1;
    }
  }

  .sort-filter-btn {
    border-radius: 24px;
    background: $grey-light;
    border: none;
    padding: 10px 0px;
    width: 95px;
  }

  .applied-filters-count {
    background: $black;
    color: white;
    font-size: 12px;
    height: 16px;
    margin-right: 5px;
    padding: 0px;
    width: 16px;
  }

  .button-text {
    @include font-weight-medium;
    font-size: 16px;
    color: $black;
    text-transform: uppercase;
  }

  .capitalize-text {
    text-transform: capitalize;
    font-weight: normal;
  }

  .filter-icon {
    background-image: url('../../../assets/images/beauty-perks/filter.svg');
    width: 15px;
    height: 15px;
    margin-left: 10px;
    margin-bottom: -3px
  }

  .reviews-sort,
  .reviews-filter {
    background: $white;
    border: 1px solid #ccc;
    border-top: 0;
    font-size: 14px;
    letter-spacing: 2px;
    overflow: auto;
    position: absolute;
    left: 10px;
    right: 10px;
    z-index: 2;
  }

  .option-container {
    border-radius: 13px;
    position: absolute;
    width: 100px;
    background: #FFF;
    box-shadow: 1px 1px #cac9c9;
    font-size: 14px;
    letter-spacing: 2px;
    overflow: auto;
    z-index: 2;
  }

  .sort-filter-container {
    margin-top: -1px;
    box-sizing: border-box;
    letter-spacing: 1px;
    max-height: 200px;
    padding-top: 8px;
    border: 0;
    padding: 0;

    .sort-filter-option {
      border-top: 1px solid #ccc;
      padding: 8px 5%;
      border-top: 1px solid #ccc;
      @include font-weight-book;
      text-align: left;

      .option-text {
        padding: 0;
        color: $black;
        border: 0;
        display: inline-block;
        padding-bottom: 4px;
        pointer-events: none;
      }
    }

    .selected {
      height: 15px;
      width: 15px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      pointer-events: none;
      background: url('../../../assets/images/icons/selected-tick.svg');
    }

    .unselected {
      height: 15px;
      width: 15px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }
  }

  .dropdown-nav {
    width: 10px;
    height: 10px;
    display: inline-block;
    margin-left: 5px;
    margin-top: 0;
    position: relative;
  }

  .us-filter-container {
    padding-top: 20px;
  }
</style>
